import storage from 'src/storage'

export const apiUrl =
  process.env.GATSBY_API_URL || 'http://localhost:8080/v1/api'

export const priceDecimals = Number(storage.getItem('priceDecimals') || 2)
